import styled from 'styled-components'
import { Container as DefaultContainer } from '@material-ui/core'
import { spacing } from 'helpers'

export const Container = styled(DefaultContainer)`
  padding-top: ${spacing(2)};
  position: relative;
`
